import type { RightClickTargetResolver } from "@/components/Map/RightClickMenu/RightClickMenuStore";

const MARKER_LAYER_ID = "markers-layer";
const CONNECTION_LINE_LAYER_ID = "network-connections-line";

/** What a right-click on the map resolved to. */
export type MapRightClickTarget = { kind: "map" } | { kind: "marker"; id: string } | { kind: "connection"; id: number };

/**
 * Resolves a map right-click into a {@link MapRightClickTarget}. Markers win over
 * connections when both sit under the cursor (markers render above the lines).
 */
export const resolveMapRightClickTarget: RightClickTargetResolver<MapRightClickTarget> = ({ map, point }) => {
	const mapPoint: [number, number] = [point.x, point.y];

	if (map.getLayer(MARKER_LAYER_ID)) {
		const markerFeatures = map.queryRenderedFeatures(mapPoint, { layers: [MARKER_LAYER_ID] });
		const markerRawId = markerFeatures[0]?.properties?.id;
		if (markerRawId != null) return { kind: "marker", id: String(markerRawId) };
	}

	if (map.getLayer(CONNECTION_LINE_LAYER_ID)) {
		const connectionFeatures = map.queryRenderedFeatures(mapPoint, { layers: [CONNECTION_LINE_LAYER_ID] });
		const connectionRawId = connectionFeatures[0]?.properties?.id;
		if (connectionRawId != null && Number.isFinite(Number(connectionRawId))) {
			return { kind: "connection", id: Number(connectionRawId) };
		}
	}

	return { kind: "map" };
};
